// extracted by mini-css-extract-plugin
export default {"userTableHeadingsActions":"users-page-module__userTableHeadingsActions--Edkqg","userTable":"users-page-module__userTable--EEifr"};